import React, {useState} from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Image,
  Input,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Progress,
  Select,
  useDisclosure, useToast
} from "@chakra-ui/react";
import Plus from "../../../images/teacher/plus.svg";
import {Flex} from "@chakra-ui/layout";
import axios from "axios";
import {useSelector} from "react-redux";
import {StateType} from "../../../store/store";
import {NavLink} from "react-router-dom";

function TeacherAssignments() {
  const {data, courses: {courses}} = useSelector((state: StateType) => state.rootReducer.teacherReducer);
  const teacherToken = data.token.includes("Bearer") ? data.token.slice(17, (data.token.length - 2)) : data.token.slice(10, (data.token.length - 2));
  const {isOpen, onOpen, onClose} = useDisclosure();
  const [assignment, setAssignment] = useState<FileList | null>(null);
  const [courseGrade, setCourseGrade] = useState<string>("");
  const [dueDate, setDueDate] = useState<string>("");
  const [courseWork, setCourseWork] = useState<string>("");
  const [assignmentError, setAssignmentError] = useState<string>("");
  const [fileError, setFileError] = useState<string>("");
  const [loaded, setLoaded] = useState(0);
  const [courseGradeError, setCourseGradeError] = useState<string>("");
  const [dueDateError, setDueDateError] = useState<string>("");
  const [courseWorkError, setCourseWorkError] = useState<string>("");
  const toast = useToast()

  async function handleAssignmentUpload(e: React.ChangeEvent<HTMLInputElement>) {
    console.log(e.target.files);
    let files = e.target.files;
    let size = 3221225472; //3gb
    // check size and length
    if (files === null) return;
    if (files.length > 3) {
      console.log("files more than 3");
      setFileError("you cannot upload more than 3 files")
      files = null;
      return;
    }
    // ensure video and audio files are not uploaded
    const types = ['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'application/vnd.ms-powerpoint.presentation.macroEnabled.12', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/msword', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    for (let x = 0; x < files.length; x++) {
      // compare file type find doesn't match
      if (types.every(type => !(files) || files[x].type !== type)) {
        // create error message and assign to container
        setFileError(files[x].type + ' is not a supported format');
        return files = null;
      }
    }
    // check size
    for (let x = 0; x < files.length; x++) {
      if (files[x].size > size) {
        setFileError(files[x].type + "is too large, please pick a smaller file");
        return files = null;
      }
    }
    setFileError("")
    if (fileError !== "") {
      files = null;
      return
    }
    setAssignment(files)
  }

  async function handleSubmit(e: React.FormEvent<HTMLButtonElement>) {
    e.preventDefault();
    if (courseGrade === "") {
      return setCourseGradeError("Please enter a grade fot this assignment");
    }
    setCourseGradeError("");
    if (courseGrade.length < 1 || courseGrade.length > 3) {
      return setCourseGradeError("Please ensure that the grade isn't more than 3 numbers or less than 1");
    }
    setCourseGradeError("");
    if (dueDate === "") {
      return setDueDateError("This field can't be left blank");
    }
    setDueDateError("")
    if (courseWork === "") {
      return setCourseWorkError("Please choose a course");
    }
    setCourseWorkError("")
    if (assignment === null) {
      return setAssignmentError("Please choose a file to upload")
    }
    setAssignmentError("");
    const formData = new FormData();
    formData.append("courseGrade", courseGrade)
    formData.append("dueDate", dueDate)
    formData.append("courseWork", courseWork)
    for (let x = 0; x < assignment.length; x++) {
      //console.log(assignment[x]);
      formData.append(assignment[x].name, assignment[x]);
    }
    let store = [];
    // @ts-ignore
    for (let key of formData.entries()) {
      //console.log(key)
      store.push(key)
    }
    console.log(store);
    const res = await axios.post("/user/teacher/assignment-upload", formData, {
      headers: {
        'content-type': 'multipart/form-data',
        "Authorization": `Bearer ${teacherToken}`
      },
      onUploadProgress: progressEvent => {
        setLoaded(progressEvent.loaded / progressEvent.total * 100)
      }
    })
    console.log(res);
    toast({
      title: "Upload Status",
      description: `${res.data.message}`,
      status: "success",
      duration: 9000,
      isClosable: true,
    })
  }

  return (
    <Flex justifyContent={"center"} mt={10} flexDirection={"row"}>
      <Flex flexDirection={"column"}>
        <Button onClick={onOpen} bgColor={"white"} fontSize={"sm"} fontWeight={"semibold"} borderRadius={"2xl"}
                size={"lg"} mb={10}>
          <Image
            boxSize="30px"
            objectFit="cover"
            mr={"12px"}
            src={Plus}
            alt="add icon"
          />
          Assignment
        </Button>

        <Link as={NavLink} to={"/tutor/assignments/uploaded-assignments"} p={4} boxShadow="2xl" bgColor={"brand.darkGreen"}
              textAlign={"center"} borderRadius={"20px"} fontWeight={"bold"}
              _hover={{color: "blue", textDecoration: "none"}}>
          Uploaded Assignments
        </Link>

        <Link as={NavLink} to={"/tutor/assignments/submitted-assignments"} mt={3} p={4} boxShadow="2xl" bgColor={"brand.darkGreen"}
              textAlign={"center"} borderRadius={"20px"} fontWeight={"bold"}
              _hover={{color: "blue", textDecoration: "none"}}>
          Submitted Assignments
        </Link>
      </Flex>

      <Modal closeOnOverlayClick={true} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay/>
        <ModalContent>
          <ModalHeader>Assignment</ModalHeader>
          <ModalCloseButton/>
          <ModalBody pb={6}>
            <form encType="multipart/form-data">
              <Alert d={fileError === "" ? "none" : "flex"} status="error">
                <AlertIcon/>
                <AlertTitle mr={2}>{fileError}</AlertTitle>
              </Alert>
              <FormControl isInvalid={courseGradeError !== ""}>
                <FormLabel htmlFor={"grade"} fontWeight={"semibold"}>Grade/Marks</FormLabel>
                <Input type={"text"} required minLength={1} maxLength={3} value={courseGrade}
                       onChange={(e) => setCourseGrade(e.target.value)}/>
                <FormErrorMessage>{courseGradeError}</FormErrorMessage>
              </FormControl>
              <FormControl mt={3} isInvalid={dueDateError !== ""}>
                <FormLabel htmlFor={"due-date"} fontWeight={"semibold"}>Due Date</FormLabel>
                <Input type={"text"} min={5} max={35} placeholder={"eg: Thursday, 27th may"} required value={dueDate}
                       onChange={(e) => (setDueDate(e.target.value))}/>
                <FormErrorMessage>{dueDateError}</FormErrorMessage>
              </FormControl>
              <FormControl mt={3} isInvalid={courseWorkError !== ""}>
                <FormLabel htmlFor={"assignment-course"} fontWeight={"semibold"}>Course</FormLabel>
                <Select required value={courseWork} onChange={(e) => setCourseWork(e.target.value)}
                        placeholder="Choose course to give assignment for">
                  {courses.map((course: any, index) => (
                    <option key={index} value={course.course_id}>{course.course_name}</option>
                  ))}
                </Select>
                <FormErrorMessage>{courseWorkError}</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={assignmentError !== null} my={5}>
                <FormLabel htmlFor={"assignment"} fontWeight={"semibold"}>Assignment Question</FormLabel>
                <input id={"assignment"} type="file" multiple onChange={(e) => handleAssignmentUpload(e)}/>
                <FormErrorMessage>{assignmentError}</FormErrorMessage>
              </FormControl>
              <Progress hasStripe value={loaded} max={100} mb={4}/>
              <Button type={"submit"} bgColor={"brand.darkGreen"} onClick={(e) => handleSubmit(e)}>upload
                assignment</Button>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

export default TeacherAssignments;